import { render, staticRenderFns } from "./MyInfo.vue?vue&type=template&id=fed4bf0e&scoped=true&"
import script from "./MyInfo.vue?vue&type=script&lang=js&"
export * from "./MyInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyInfo.vue?vue&type=style&index=0&id=fed4bf0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed4bf0e",
  null
  
)

export default component.exports